module.exports = __webpack_public_path__ + "static/img/avatar.e9e9e5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatar.png
// module id = zQrT
// module chunks = 0